// extracted by mini-css-extract-plugin
export default {"dnavbar":"Navbar_dnavbar__hb2EW","dlogo":"Navbar_dlogo__PhU1e","dbrand":"Navbar_dbrand__JvTJu","dnav_links":"Navbar_dnav_links__acvFW","dnav_account":"Navbar_dnav_account__bUdwG"};